
import crossIcon from './cross.svg';
import cartIcon from './carticon.svg';
import fullstar from './fullstar.svg';
import halfstar from './halfstar.svg';

export const assets = {
    cartIcon,
    fullstar,
    halfstar,
    crossIcon
}